module.exports = __webpack_public_path__ + "img/credit-card-google.3657555e.png";